import { render, staticRenderFns } from "./login.vue?vue&type=template&id=28dcdc75"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"
import style0 from "./login.vue?vue&type=style&index=0&id=28dcdc75&lang=css"
import style1 from "./login.vue?vue&type=style&index=1&id=28dcdc75&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28dcdc75')) {
      api.createRecord('28dcdc75', component.options)
    } else {
      api.reload('28dcdc75', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=28dcdc75", function () {
      api.rerender('28dcdc75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loginreg/login.vue"
export default component.exports